export const USER_THEMES_VALUES = ['light', 'dark'] as const;

export type UserTheme = (typeof USER_THEMES_VALUES)[number];

export const USER_THEMES_LABELS: Record<UserTheme, string> = {
  light: 'Light',
  dark: 'Dark',
};
